import { BaseComponent } from '../BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectConfig } from '../../modules/Api/selectors';
import env from '../../env';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithInstallationClientComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    if (this.props.appClientId != env.clientId) return null;

    return this.props.children;
  }
}

WithInstallationClientComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WithInstallationClient = compose(withConnect, withRouter)(WithInstallationClientComp);
